import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6c4a44de"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "activation-page" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "activation-bg-pattern" }, null, -1))
const _hoisted_3 = { class: "activation-container fade-in" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "activation-header" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "logotipo",
    src: "/logo-white.png",
    alt: "logo"
  })
], -1))
const _hoisted_5 = {
  key: 0,
  class: "activation-card has-text-centered"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "loading-spinner" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-circle-notch" })
], -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "A ativar a sua conta...", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Aguarde um momento por favor", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-arrow-left mr-2" }, null, -1))
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" Voltar ao login ")
const _hoisted_11 = {
  key: 1,
  class: "activation-card has-text-centered"
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "result-icon success" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-check" })
], -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Conta ativada!", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "A sua conta foi ativada com sucesso.", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "result-subtitle" }, "Pode começar agora a gerir o seu Goldylocks.", -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-sign-in-alt mr-2" }, null, -1))
const _hoisted_17 = /*#__PURE__*/_createTextVNode(" Abrir área de cliente ")
const _hoisted_18 = {
  key: 2,
  class: "activation-card has-text-centered"
}
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "result-icon error" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times" })
], -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Erro!", -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Não foi possível ativar a sua conta.", -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "result-subtitle" }, "O link pode ter expirado ou a conta já se encontra ativa.", -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-arrow-left mr-2" }, null, -1))
const _hoisted_24 = /*#__PURE__*/_createTextVNode(" Voltar ao login ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      (_ctx.isActivating)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _hoisted_6,
            _hoisted_7,
            _hoisted_8,
            _createVNode(_component_router_link, {
              class: "button is-link mt-4",
              to: "/login"
            }, {
              default: _withCtx(() => [
                _hoisted_9,
                _hoisted_10
              ]),
              _: 1
            })
          ]))
        : (_ctx.isActivated)
          ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
              _hoisted_12,
              _hoisted_13,
              _hoisted_14,
              _hoisted_15,
              _createVNode(_component_router_link, {
                class: "button is-primary mt-4",
                to: "/login"
              }, {
                default: _withCtx(() => [
                  _hoisted_16,
                  _hoisted_17
                ]),
                _: 1
              })
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_18, [
              _hoisted_19,
              _hoisted_20,
              _hoisted_21,
              _hoisted_22,
              _createVNode(_component_router_link, {
                class: "button is-link mt-4",
                to: "/login"
              }, {
                default: _withCtx(() => [
                  _hoisted_23,
                  _hoisted_24
                ]),
                _: 1
              })
            ]))
    ])
  ]))
}